import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  private _browser: boolean;

  constructor() {
    const platformId = inject(PLATFORM_ID);

    this._browser = isPlatformBrowser(platformId);
  }

  get isBrowser(): boolean {
    return this._browser;
  }
}
